<template>
    <Card>
        <FetchTable
            :handle="tableHandle"
            :url="url"
            :columns="columns"
        >
            <template #td-sms_template="{ row }">
                {{ row?.sms_template?.api_credentials?.name }}
            </template>
            <template #td-created_at="{ row }">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";
import DateFormatter from "../../../../../services/DateFormatter";

export default {
    name: "OrderSmsPage",
    components: {
        Card, FetchTable
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            url: `/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/sms`,
            columns: [
                { key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true },
                { key: 'sms_template', name: this.$t('table.titles.sms_template'), width: '200px', type: 'string', order: false },
                { key: 'text', name: this.$t('table.titles.text'), width: '200px', type: 'string', order: false },
                { key: 'external_number', name: this.$t('table.titles.external_id'), width: '200px', type: 'string', order: false },
                { key: 'cost', name: this.$t('table.titles.cost'), width: '200px', type: 'string', order: false },
                { key: 'phone', name: this.$t('table.titles.recipient'), width: '200px', type: 'string', order: false },
                { key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true },
            ]
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>